// extracted by mini-css-extract-plugin
export var background = "_g1-6";
export var containerMedium = "_g1-0";
export var containerMicro = "_g1-2";
export var containerSmall = "_g1-1";
export var dropdown = "_g1-5";
export var dropdownLabel = "_g1-a";
export var enter = "_g1-7";
export var exitActive = "_g1-8";
export var label = "_g1-3";
export var option = "_g1-9";
export var select = "_g1-4";